export const DRAGONBONES_PATH: string = 'resource/dragonbones';
export const CARD_MODIFIER_DRAGONBONES_PATH = `${DRAGONBONES_PATH}/Cards/Modifiers`
export const CARD_DRAGONBONES_PATH = `${DRAGONBONES_PATH}/Cards`
